import gql from 'graphql-tag';

export default gql`
  mutation createWorkflow($workflow: WorkflowInput) {
    createWorkflow(workflow: $workflow) {
      _id
      _created
      _updated
      _createdBy
      _updatedBy
      _order
      event
      name
      when
      whenContext
      inStatus
      time
      action
      target
      targetType
      payload
      workflow
      dataValidationSchema
      type
      channelId
      deletedAt
      groupRole
    }
  }
`;
